import Vue from 'vue'
import RemindDialog from '@/components/RemindDialog/index'
// import CustomList from '@/components/CustomList/index'
import Empty from '@/components/Empty/index'

Vue.component('RemindDialog', RemindDialog)
// Vue.component('CustomList', CustomList)
Vue.component('Empty', Empty)

